import { Component, OnInit } from '@angular/core';
import { ReportService } from 'src/app/services/report.service';
import { ReportActivationModel } from 'src/app/models/report.model';
import { MessageService } from 'primeng/api';
import { ExcelService } from 'src/app/services/excel.service';

@Component({
  selector: 'app-rpt-activacion',
  templateUrl: './rpt-activacion.component.html',
  styleUrls: ['./rpt-activacion.component.css']
})
export class RptActivacionComponent implements OnInit {

  selectedOption: string;
  colsTablaRptActivation;
  datasourceRptActivation: ReportActivationModel[] = [];
  secuencial: number;
  disabledSecuencial: boolean = true;
  bin: number;
  disabledBin: boolean = true;
  fecini: Date;
  fecfin: Date;
  disabledFec: boolean = true;
  loading: boolean = false;
  disabledButton: boolean = true;

  constructor(private reportService: ReportService,
    private messageService: MessageService,
    private excelService: ExcelService) { }

  ngOnInit() {
    this.createColumnsTablaRptActivation();
  }

  createColumnsTablaRptActivation(){
    this.colsTablaRptActivation = [
        { field: 'ORDEN_COMPRA', header: 'Orden de Compra', width: '8%', align : 'center'},
        { field: 'CLIENTE', header: 'Cliente', width: '15%', align : 'center'},
        { field: 'MODELO_GIFT_CARD', header: 'Modelo Tarjeta', width: '15%', align : 'center'},
        { field: 'NUMERO_TARJETA', header: 'Nro. Tarjeta', width: '8%', align : 'center'},
        { field: 'SECUENCIAL', header: 'Secuencial', width: '5%', align : 'center'},
        { field: 'FEC_INICIO_VIGENCIA', header: 'Fec. Ini. Vigencia', width: '6%', align : 'center'},
        { field: 'FEC_FIN_VIGENCIA', header: 'Fec. Fin Vigencia', width: '6%', align : 'center'},
        { field: 'USUARIO', header: 'Usuario', width: '5%', align : 'center'},
        { field: 'MONTO_ACTIVACION', header: 'Monto Activación', width: '5%', align : 'center'}
    ];
  }

  populateTablaRptActivation(){
    this.loading = true;
    if (this.selectedOption == "SEC" && (!(this.secuencial) || this.secuencial == 0)){
      this.messageService.add({severity:'error', summary: 'Error', detail:'Debe ingresar un secuencial válido.'});
      this.loading = false;
    } 
    else if (this.selectedOption == "BIN" && (!(this.bin) || this.bin == 0)){
      this.messageService.add({severity:'error', summary: 'Error', detail:'Debe ingresar un track/bin válido.'});
      this.loading = false;
    } 
    else if (this.selectedOption == "FEC" && (!(this.fecini))){
      this.messageService.add({severity:'error', summary: 'Error', detail:'Debe ingresar una fecha de inicio de vigencia válida.'});
      this.loading = false;
    }
    else if (this.selectedOption == "FEC" && (!(this.fecfin))){
      this.messageService.add({severity:'error', summary: 'Error', detail:'Debe ingresar una fecha de fin de vigencia válida.'});
      this.loading = false;
    } 
    else{
      let params = {
        "p_bin_giftcard" : this.bin ? this.bin : 0,
        "p_id_secuence_ncr" : this.secuencial ? this.secuencial : 0,
        "p_fec_ini_vigencia" : this.fecini ? this.fecini.getDate() + "/" + (this.fecini.getMonth() + 1) + "/" + this.fecini.getFullYear() : "",
        "p_fec_fin_vigencia" : this.fecfin ? this.fecfin.getDate() + "/" + (this.fecfin.getMonth() + 1) + "/" + this.fecfin.getFullYear() : ""
      }
      console.log(params);
      this.reportService.GetReporteActivation(params).subscribe(
        (response : ReportActivationModel[]) =>{
          this.datasourceRptActivation = response;
          this.loading = false;
          if (this.datasourceRptActivation.length == 0){
            this.messageService.add({severity:'warn', summary: 'Alerta', detail:'No se encontraron resultados para la búsqueda ingresada'});
          }
        },
        (error) => {
          this.loading = false;
          this.messageService.add({severity:'error', summary: 'Error', detail:'Se produjo un error al realizar la consulta.'});
        });    
    }
  }

  exportAsXLSX():void {
    if (this.datasourceRptActivation.length == 0){
      this.messageService.add({severity:'warn', summary: 'Alerta', detail:'No existen información para la exportación'});
      return;
    }
    this.excelService.exportAsExcelFile(this.datasourceRptActivation, 'report');
  }

  changeSelectionOption(){
    this.disabledButton = false;
    switch(this.selectedOption){
      case "SEC":
          this.disabledSecuencial = false;
          this.disabledFec = true;
          this.disabledBin = true;          
          this.clean();
          break;
      case "BIN":
          this.disabledSecuencial = true;
          this.disabledFec = true;
          this.disabledBin = false;
          this.clean();
          break;
      case "FEC":
          this.disabledSecuencial = true;
          this.disabledFec = false;
          this.disabledBin = true;
          this.clean();
          break;
      default:
          break;
    }
  }

  clean(){
    this.secuencial = null;
    this.bin = null;
    this.fecini = null;
    this.fecfin = null;
  }

  
}
